import BootstrapVue from "bootstrap-vue"
import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import { createProvider } from "./vue-apollo"
import "./registerServiceWorker"

import axios from "axios"
import VueAxios from "vue-axios"

import VueInstaller from "vue-pwa-installer"
Vue.use(VueInstaller, {})

import omitDeep from "omit-deep"
Vue.prototype.$omitDeep = omitDeep



// import VueTagManager from "vue-tag-manager"
// Vue.use(VueTagManager, {
//   gtmId: 'UA-151972365-1'
// })

import "./vueformulate"

import Sticky from "vue-sticky-directive"
Vue.use(Sticky)

import "vue-context/dist/css/vue-context.css"

const API_URL = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000"
axios.defaults.baseURL = API_URL
axios.defaults.headers.post["Content-Type"] = "application/json"
const token = localStorage.getItem("token")
if (token) {
	axios.defaults.headers.common["Auth"] = token
}
Vue.use(VueAxios, axios)

import store from "./store" // your vuex store

Vue.config.productionTip = false

Vue.use(BootstrapVue)
require("bootstrap/dist/css/bootstrap.css")
require("bootstrap-vue/dist/bootstrap-vue.css")

import "vue-slick-carousel/dist/vue-slick-carousel.css"
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css"

require("@/assets/css/font-awesome.css")
require("@/assets/css/icon_fonts/elegant-icons.css")
require("@/assets/css/icon_fonts/pe-icons.css")
require("@/assets/css/icon_fonts/fontello-icons.css")
require("vue2-animate/dist/vue2-animate.min.css")
require("@/assets/css/custom.css")

import Pagination from "@/components/layout/Pagination"
Vue.component("Pagination", Pagination)
import Layout from "@/components/layout/Layout"
Vue.component("Layout", Layout)
import Loader from "@/components/layout/Loader"
Vue.component("Loader", Loader)

import VuejsDialog from "vuejs-dialog"
import "vuejs-dialog/dist/vuejs-dialog.min.css"
Vue.use(VuejsDialog, {
	okText: "Confirmar",
	cancelText: "Cancelar",
	html: true
})

import vSelect from "vue-select"
Vue.component("v-select", vSelect)

import ToggleButton from "vue-js-toggle-button"
Vue.use(ToggleButton)

import VueTextareaAutosize from "vue-textarea-autosize"
Vue.use(VueTextareaAutosize)

import VueToast from "vue-toast-notification"
import "vue-toast-notification/dist/index.css"
Vue.use(VueToast, { position: "top-right" })

import Multiselect from "vue-multiselect"
Vue.component("multiselect", Multiselect)
import "vue-multiselect/dist/vue-multiselect.min.css"

const moment = require("moment")
require("moment/locale/es")
Vue.use(require("vue-moment"), { moment })

import DateRangePicker from "vue2-daterange-picker"
import "vue2-daterange-picker/dist/vue2-daterange-picker.css"
Vue.component("date-range-picker", DateRangePicker)

import Meta from "vue-meta"
Vue.use(Meta)

new Vue({
	router,
	store,
	apolloProvider: createProvider(),
	render: h => h(App)
}).$mount("#app")
